import Box from 'components/Box';
import styled from 'styled-components';

const LoadingContent = styled(Box)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.35);
`;

const Icon = styled(Box)`
  position: absolute;
  width: 60px;
  height: 60px;
  top: 50%;
  left: 50%;
  margin-left: -30px;
  margin-top: -30px;
  border-radius: 30px;
  background-color: #aa81f3;
  padding: 22px 12px;
  box-shadow: 0 0 24px -8px rgb(0 0 0 / 75%);
`;

export { LoadingContent, Icon };
